import React, { useState } from "react";
import {
  Table,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { useTheme } from "../../context/ThemeContext";
import { formatToIST } from "../../utils/dateUtils";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import BlockFlippedIcon from '@mui/icons-material/BlockFlipped';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

interface Props {
  users: any[];
  loading: boolean;
  onEdit: (u: any) => void;
  onDelete: (u: any) => void;
  onReset: (u: any) => void;
  onToggleStatus: (u: any) => void;
}

const roleColors: any = {
  Admin: "danger",
  Coordinator: "primary",
  Guest: "secondary"
};

const UserTable: React.FC<Props> = ({
  users,
  loading,
  onEdit,
  onDelete,
  onReset,
  onToggleStatus
}) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  return (
    <Table
      hover
      responsive
      dark={isDark}
      className="align-middle"
    >
      <thead className={isDark ? "" : "table-light"}>
        <tr>
          <th>User</th>
          <th>Role</th>
          <th>Status</th>
          <th>Phone</th>
          <th>Created</th>
          <th>Last Login</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {users.map((u) => (
          <tr key={u.userId}>
            
            {/* Avatar + Name */}
            <td>
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                  style={{
                    width: 40,
                    height: 40,
                    fontWeight: 600
                  }}
                >
                  {u.name?.charAt(0).toUpperCase()}
                </div>
                <div>
                  <div className="fw-semibold">{u.name}</div>
                  <div className="small text-muted">{u.email}</div>
                </div>
              </div>
            </td>

            {/* Role */}
            <td>
              <Badge color={roleColors[u.role]}>
                {u.role}
              </Badge>
            </td>

            {/* Status */}
            <td>
              <Badge color={u.isActive ? "success" : "secondary"}>
                {u.isActive ? "Active" : "Inactive"}
              </Badge>
            </td>

            <td>{u.phoneNumber}</td>

            <td>
              {new Date(u.createdAt).toLocaleDateString()}
            </td>
          <td>{u.loginAt ? formatToIST(u.loginAt) : "-"}</td>

            {/* Actions */}
<td className="text-end">
  <div
    className="d-flex justify-content-end align-items-center gap-3"
  >
    {/* Edit */}
    <ModeEditIcon
      onClick={() => onEdit(u)}
      style={{
        cursor: "pointer",
        fontSize: "20px",
        color: "#4dabf7",
      }}
    />

    {/* Delete */}
{u.role?.toLowerCase() !== "admin" && (
  <DeleteIcon
    onClick={() => onDelete(u)}
    style={{
      cursor: "pointer",
      fontSize: "20px",
      color: "#fa5252",
    }}
  />
)}

    {/* Activate / Deactivate */}

<span
  title={u.isActive ? "Deactivate User" : "Activate User"}
  style={{ cursor: "pointer" }}
>
  <BlockFlippedIcon
    onClick={() => onToggleStatus(u)}
    style={{
      color: u.isActive ? "#10ff38" : "#615959",
      fontSize: "20px",
    }}
  />
</span>
 {/* Reset Password */}
    <RestartAltIcon
      onClick={() => onReset(u)}
      style={{
        cursor: "pointer",
        fontSize: "20px",
        color: "#845ef7",
      }}
    />
  </div>
</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default UserTable;